var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.78,
    height: 43.515,
    viewBox: "0 0 375.78 43.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Curve_underline_yellow",
    "data-name": "Curve underline yellow",
    transform: "translate(1.183 0.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "matrix(1, 0.017, -0.017, 1, 1.325, 0.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,23S233.459-13.064,365,7.42",
    transform: "translate(0.821 1.514)",
    fill: "none",
    stroke: "#ffb840",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,19.826S237.046-13.633,369.128,9.374",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 1.701, 0.344)",
    fill: "none",
    stroke: "#ffb840",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineShape2);
export default __webpack_public_path__ + "static/media/line-shape-2.84519b77d827ac6f76ef1618307d620d.svg";
export { ForwardRef as ReactComponent };